const state = {
  activityPublc: {
    content: []
  },
  activityPublicDetail: {},
  activityPublicCount: []
}
const	getters = {
  getActivityPublic: state => {
    return state.activityPublc;
  },
  getActivityPublicDetail: state => {
    return state.activityPublcDetail;
  },
  getActivityPublicCount: state => {
    return state.activityPublicCount;
  },
}
const	mutations = {
  getactivitypublic(state, payload) {
    state.activityPublc = payload;
  },
  getactivitypublicdetail(state, payload) {
    state.activityPublcDetail = payload;
  },
  getactivitypubliccount(state, payload) {
    state.activityPublicCount = payload;
  }
}
const	actions = {
  
  reqActivityPublic( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/ScheduleBMC",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getactivitypublic', result.data);
        r();
      }).catch(() => {
        j();
      })
    })    
  },

  reqActivityPublicCount( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/ScheduleBMCSeven",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        
        commit('getactivitypubliccount', result.data)
        // console.log(result.data);
        
        r(result.data);
      }).catch(() => {
        j();
      })
    })
  },

  reqActivityPublicDetail( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/PublicShops",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getactivitypublicdetail', result.data)
        console.log(result.data);
        
        r(result.data);
      }).catch(() => {
        j();
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}